import Vue from 'vue'

// global events
export const eventBus = new Vue({
    methods: {
        newAccount(account) {
            this.$emit('newAccount', account)
        },
        newIp(ip) {
            this.$emit('newIp', ip)
        }
    }
})